import * as firebase from "firebase";
require("firebase/firestore");

var config = {
    apiKey: "AIzaSyCo_vcriac2rgesNW3BaB-6fajz5l-Jats",
    authDomain: "tzav-rishon.firebaseapp.com",
    databaseURL: "https://tzav-rishon.firebaseio.com",
    projectId: "tzav-rishon",
    storageBucket: "tzav-rishon.appspot.com",
    messagingSenderId: "53562501761",
    appId: "1:53562501761:web:2235b1fe160faceb"
};
firebase.initializeApp(config);

export const db = firebase.firestore()